import { render, staticRenderFns } from "./AdOptColumn.vue?vue&type=template&id=278d8c5e&scoped=true"
import script from "./AdOptColumn.vue?vue&type=script&lang=js"
export * from "./AdOptColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278d8c5e",
  null
  
)

export default component.exports